import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnInit, Output, signal } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectOptions } from '../../../core/interfaces/select-options.interface';
import { MatSelectModule } from '@angular/material/select';
import { ConfirmPopupComponent } from '../new-rep-application/confirm-popup/confirm-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { RmAssessmentService } from './rm-assessment-services/rm-assessment.service';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { HttpStatusCode } from 'axios';
import { viewRmAssessment } from './rm-assessment-interfaces/rm-assessment.interface';
import { RmAssessment } from './rm-assessment-models/rm-assessment.models';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OnboardingAssessmentService } from '../onboarding-assessment/onboarding-assessment-services/onboarding-assessment.service';
import { OnboardingAssesmentModel } from '../onboarding-assessment/onboarding-assesment-models/onboarding-assesment-model.model';
import { OnboardingAssesment } from '../onboarding-assessment/onboarding-assesment-interface/onboarding-assesment.interface';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AgentOnboardingService } from '../agent-onboarding/agent-onboarding-service/agent-onboarding.service';
import { NewRepChecklistService } from '../new-rep-checklist/new-rep-checklist-services/new-rep-checklist.service';
import { getChecklistItems } from '../new-rep-checklist/new-rep-checklist-interfaces/save-new-rep-checklist.interface';
import { DocumentPreviewOverlayDirective } from '../../../shared/directives/document-preview-overlay/document-preview-overlay.directive';

@Component({
  selector: 'app-rm-assessment',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    DocumentPreviewOverlayDirective
  ],
  templateUrl: './rm-assessment.component.html',
  styleUrl: './rm-assessment.component.scss'
})
export class RmAssessmentComponent implements OnInit {

  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  readonly message = ' This field is required.';
  private sanitizer = inject(DomSanitizer);
  private returnbyroleService = inject(AgentOnboardingService);
  private sessionStorageService = inject(SessionStorageService);
  private rmAssessmentService = inject(RmAssessmentService);
  private documentUploadService = inject(OnboardingAssessmentService);
  private snackBarService = inject(SnackbarService);
  private newRepChecklistService = inject(NewRepChecklistService);
  private router = inject(Router);
  setSprinner = signal(false);
  submitted = signal(false);
  errormessage!: string;

  data = history.state;
  viewId!: number;
  viewrmAssessment!: viewRmAssessment;
  isReadOnly = signal(false);
  protected currentUserRole: string = "";
  protected status: string = "";
  protected documentCategorynames!: SelectOptions[];
  getRectificationdocuments!: OnboardingAssesment[];
  protected getchecklistItems: getChecklistItems[] = [];

  /** Prefix used for the dynamically added "Other Attachments" controls. */
  readonly otherAttachmentPrefix = 'otherAttachment';
  /** Document type sent for every "Other Attachments" upload - the row index goes in responseValue. */
  readonly otherAttachmentDescription = 'OtherAttachments';
  /** Control keys of the rendered "Other Attachments" rows, e.g. ['otherAttachment1', 'otherAttachment2']. */
  otherAttachmentKeys: string[] = [];
  private otherAttachmentSeq = 0;
  /**
   * The "Other Attachments" rows of the documents list, kept apart from
   * getRectificationdocuments so the rectification FormArray's existing
   * positional lookups (removeRow / removeFile / loadFile) stay aligned.
   */
  private otherAttachmentDocuments: OnboardingAssesment[] = [];
  checklistinvalidflag = signal(false);

  selectedDocument!: SafeResourceUrl;
  isPdf = false;
  selectedItemFile!: string;
  currentFileName!: string;

  readonly MIN_ZOOM = 0.5;
  readonly MAX_ZOOM = 3;
  private readonly ZOOM_STEP = 0.25;
  zoomLevel = 1;

  protected hierarchyList: SelectOptions[] = [
    {
      value: 'T3',
      name: 'T3'
    },
    {
      value: 'T2',
      name: 'T2'
    },
    {
      value: 'T1',
      name: 'T1'
    },
  ];
  protected agentchannelList: SelectOptions[] = [
    {
      value: 'PS',
      name: 'PS'
    },
    {
      value: 'Affinity',
      name: 'Affinity'
    },
  ];

  protected designationList: SelectOptions[] = [
    {
      value: 'Wealth Management Consultant',
      name: 'Wealth Management Consultant'
    },
    {
      value: 'Senior Wealth Management Consultant',
      name: 'Senior Wealth Management Consultant'
    },
    {
      value: 'Associate Director (Advisory)',
      name: 'Associate Director (Advisory)'
    },
    {
      value: 'Associate Financial Services Manager',
      name: 'Associate Financial Services Manager'
    },
    {
      value: 'Financial Services Manager',
      name: 'Financial Services Manager'
    },
    {
      value: 'Senior Financial Services Manager',
      name: 'Senior Financial Services Manager'
    },
    {
      value: 'Associate Financial Services Director',
      name: 'Associate Financial Services Director'
    },
    {
      value: 'Financial Services Director',
      name: 'Financial Services Director'
    },
    {
      value: 'Senior Financial Services Director',
      name: 'Senior Financial Services Director'
    },
  ];

  public rmassessmentForm: FormGroup = this.fb.group({
    name: [''],
    nric: [''],
    agentchannel: ['', [Validators.required]],
    hierarchy: ['', [Validators.required]],
    designation: ['', [Validators.required]],
    representativebanding: [''],
    branch: [''],
    manager: [''],
    remarks: [''],
    declarationaccepted: ['', [Validators.required]],
    rm: [''],
    date: [''],
    rectificationAttachemnts: this.fb.array([]),
    rectificationremarks: [''],

  });

  ngOnInit(): void {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    // Logic is now handled in the property initialization above
    this.viewId = this.data.id;
    this.isReadOnly.set(this.data.isReadOnly);
    this.viewRmAssessment();
    this.getChecklistItems();
    if (this.isReadOnly() == true) {
      this.rmassessmentForm?.disable();
    } else {
      this.rmassessmentForm?.enable();
    }

    this.rmassessmentForm.get('declarationaccepted')?.valueChanges.subscribe(value => {
      if (value) {
        this.rmassessmentForm.patchValue({
          rm: this.viewrmAssessment.declaration_details.finacialServiceMan,
          date: this.getToday()
        }, { emitEvent: false });
        this.errormessage = '';
      } else {
        this.rmassessmentForm.patchValue({
          rm: null,
          date: null
        }, { emitEvent: false });
        if (value == false) {
          this.rmassessmentForm.get('declarationaccepted')?.markAllAsTouched();
        }

      }
    });

  }

  //  Generic FormArray getter
  get rectificationAttachemnts(): FormArray {
    return this.rmassessmentForm.get('rectificationAttachemnts') as FormArray;
  }

  //  Create row
  createRow(): FormGroup {
    return this.fb.group({
      categoryName: [''],
      document: [null],
      documentFilename: ['']

    });
  }

  //  Add row
  addRow(): void {
    this.rectificationAttachemnts.push(this.createRow());
  }


  async removeRow(index: number): Promise<void> {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to delete the Attachment?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.rectificationAttachemnts.length > 1) {
          if (this.getRectificationdocuments) {
            let id = this.getRectificationdocuments[index]?.id;
            let docTypeId = this.getRectificationdocuments[index]?.docTypeId;

            const data = {
              onboardingId: this.viewId,
              docTypeId: docTypeId,
              id: id
            }
            if (id != undefined) {
              const responseData = await this.documentUploadService
                .deleteonbordingdocument(data)
                .then((response) => {
                  return JSON.parse(response);
                })
                .catch((error) => {
                  // console.error(error);
                  return error;
                });
            }
          }
        }
        this.rectificationAttachemnts.removeAt(index);

      } else {
        // console.log('User cancelled');
      }
    });

  }

  onDocumentFileChange(event: any, index: number,): void {
    const file = event.target.files?.[0];
    const fileControl = this.rectificationAttachemnts.at(index).get('documentFilename');
    if (file) {
      this.rectificationAttachemnts.at(index).patchValue({
        document: file,
        documentFilename: file.name
      });
    }
    fileControl?.markAsTouched();
    fileControl?.updateValueAndValidity();
    if (!file) {
      fileControl?.setValue(null);
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    // ❌ Invalid type
    if (!allowedTypes.includes(file.type)) {
      fileControl?.setErrors({ invalidType: true });
      return;
    }

    // ❌ Invalid size
    if (file.size > maxSize) {
      fileControl?.setErrors({ maxSize: true });
      return;
    }

    // ✅ Valid file
    fileControl?.setErrors(null);
    // fileControl?.setValue(file);
    this.uploaddocument(index);
  }

  removeFile(controlName: string, fileVar: string, index: number) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.getRectificationdocuments) {
          let id;
          let docTypeId;
          this.getRectificationdocuments.forEach(item => {
            if (item?.onboardingDocumentType === this.rectificationAttachemnts.at(index).get('categoryName')?.value) {
              id = item.id,
                docTypeId = item.docTypeId
            }
          });

          const data = {
            onboardingId: this.viewId,
            docTypeId: docTypeId,
            id: id
          }
          if (id != undefined) {
            const responseData = await this.documentUploadService
              .deleteonbordingdocument(data)
              .then((response) => {
                return JSON.parse(response);
              })
              .catch((error) => {
                // console.error(error);
                return error;
              });
          }
        }
        this.rectificationAttachemnts.at(index).get(controlName)?.reset();
        const fileInput = document.getElementById(controlName) as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        this.rectificationAttachemnts.at(index).get(fileVar)?.reset();
        this.rectificationAttachemnts.at(index).get(controlName)?.markAsTouched();
        this.rectificationAttachemnts.at(index).get(controlName)?.updateValueAndValidity();
        // }
      } else {
        // console.log('User cancelled');
      }
    });
  }

  async uploaddocument(index: number) {
    this.setSprinner.set(true);
    let uploadbdmdocuments = new OnboardingAssesmentModel();
    uploadbdmdocuments.setOnboardingid(this.viewId);
    uploadbdmdocuments.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    uploadbdmdocuments.setAttachments([{
      onboardingid: this.viewId,
      docTypeId: 0,
      category_name: this.rectificationAttachemnts.at(index).get('categoryName')?.value,
      fileName: this.rectificationAttachemnts.at(index).get('document')?.value?.name,
      data: this.rectificationAttachemnts.at(index).get('document')?.value instanceof Blob ? await this.convertToBase64(this.rectificationAttachemnts.at(index).get('document')?.value) : '',
      contentType: this.rectificationAttachemnts.at(index).get('document')?.value.type,
      responseValue: ''
    }]);

    const responseData = await this.documentUploadService
      .saveOnboardingassessment(uploadbdmdocuments)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
      this.viewRmAssessment();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }

    }
  }

  // ---------- Other Attachments ----------

  /**
   * Restores any previously uploaded "Other Attachments" and always keeps at
   * least one empty row. Safe to call repeatedly (viewRmAssessment() runs again
   * after every upload) - restoreOtherAttachment() only adds unseen controls.
   */
  private buildOtherAttachments(): void {
    this.otherAttachmentDocuments.forEach(item => {
      const index = this.otherAttachmentIndexOf(item);
      if (index !== null) {
        this.restoreOtherAttachment(`${this.otherAttachmentPrefix}${index}`, item.fileName);
      }
    });

    if (this.otherAttachmentKeys.length === 0) {
      this.addOtherAttachment();
    }

    // The API lists the documents in its own order, so the rows are put back in row
    // order here. Left unsorted the fields swap places on every fetch, and because
    // the template hangs the remove button off every row but the first and the add
    // button off the last, those buttons end up on whichever rows came back first.
    this.otherAttachmentKeys.sort((a, b) => this.otherAttachmentRow(a) - this.otherAttachmentRow(b));
  }

  /** The row index sent as responseValue for an "Other Attachments" control key. */
  private otherAttachmentIndex(key: string): string {
    return key.slice(this.otherAttachmentPrefix.length);
  }

  /** Row index of a control key as a number, for matching and ordering. */
  private otherAttachmentRow(key: string): number {
    return Number(this.otherAttachmentIndex(key));
  }

  /**
   * Row index an uploaded document belongs to, or null when it isn't an "Other
   * Attachments" row. Uploads carry 'OtherAttachments' as the document type with
   * the index in responseValue; rows saved before that change kept the index in
   * the document type itself, so both shapes are recognised here. The index is
   * read as a number so a row is still matched when the API echoes it back in a
   * different form (' 2', 2) than the one that was sent.
   */
  private otherAttachmentIndexOf(item: OnboardingAssesment | undefined): number | null {
    const docType = item?.onboardingDocumentType ?? '';
    const raw = docType === this.otherAttachmentDescription
      ? String(item?.responseValue ?? '').trim()
      : docType.startsWith(this.otherAttachmentPrefix)
        ? docType.slice(this.otherAttachmentPrefix.length)
        : '';

    const row = Number(raw);
    return raw !== '' && Number.isFinite(row) ? row : null;
  }

  /** Locates the uploaded document behind an "Other Attachments" row, matched on its index. */
  private findOtherAttachmentDocument(key: string): OnboardingAssesment | undefined {
    const row = this.otherAttachmentRow(key);
    return this.otherAttachmentDocuments.find(item => this.otherAttachmentIndexOf(item) === row);
  }

  private restoreOtherAttachment(key: string, fileName: string): void {
    if (!this.otherAttachmentKeys.includes(key)) {
      this.rmassessmentForm.addControl(key, this.fb.control([null]));
      this.rmassessmentForm.addControl(`${key}fileName`, this.fb.control(''));
      this.otherAttachmentKeys.push(key);

      const seq = Number(key.slice(this.otherAttachmentPrefix.length));
      if (!Number.isNaN(seq) && seq > this.otherAttachmentSeq) {
        this.otherAttachmentSeq = seq;
      }
    }
    this.rmassessmentForm.get(`${key}fileName`)?.setValue(fileName);
  }

  /** Duplicates the "Other Attachments" field so another file can be attached. */
  addOtherAttachment(): void {
    const key = `${this.otherAttachmentPrefix}${++this.otherAttachmentSeq}`;
    this.rmassessmentForm.addControl(key, this.fb.control([null]));
    this.rmassessmentForm.addControl(`${key}fileName`, this.fb.control(''));
    this.otherAttachmentKeys.push(key);
  }

  /** Removes a duplicated "Other Attachments" row, deleting its uploaded file first when there is one. */
  removeOtherAttachment(key: string): void {
    if (!this.rmassessmentForm.get(`${key}fileName`)?.value) {
      this.dropOtherAttachment(key);
      return;
    }

    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result?.data === true) {
        await this.deleteOtherAttachmentDocument(key);
        this.dropOtherAttachment(key);
      }
    });
  }

  /** Clears the uploaded file but keeps the "Other Attachments" field on screen. */
  removeOtherAttachmentFile(key: string): void {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result?.data !== true) {
        return;
      }

      await this.deleteOtherAttachmentDocument(key);

      this.rmassessmentForm.get(key)?.reset();
      this.rmassessmentForm.get(`${key}fileName`)?.reset();
      const fileInput = document.getElementById(`${key}fileName`) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
      this.rmassessmentForm.get(`${key}fileName`)?.markAsTouched();
      this.rmassessmentForm.get(`${key}fileName`)?.updateValueAndValidity();
    });
  }

  private async deleteOtherAttachmentDocument(key: string): Promise<void> {
    const match = this.findOtherAttachmentDocument(key);
    if (!match?.id) {
      return;
    }

    const data = {
      onboardingId: this.viewId,
      docTypeId: match.docTypeId,
      id: match.id
    };

    await this.documentUploadService
      .deleteonbordingdocument(data)
      .then((response) => JSON.parse(response))
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.otherAttachmentDocuments = this.otherAttachmentDocuments.filter(item => item !== match);
  }

  private dropOtherAttachment(key: string): void {
    this.rmassessmentForm.removeControl(key);
    this.rmassessmentForm.removeControl(`${key}fileName`);
    this.otherAttachmentKeys = this.otherAttachmentKeys.filter(item => item !== key);
  }

  onOtherAttachmentFileChange(event: any, key: string): void {
    const file = event.target.files?.[0];
    const fileControl = this.rmassessmentForm.get(`${key}fileName`);

    this.rmassessmentForm.patchValue({
      [key]: file,
      [`${key}fileName`]: file?.name
    });

    if (!fileControl) return;

    fileControl.markAsTouched();
    fileControl.setErrors(null);

    if (!file) {
      fileControl.setValue(null);
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.includes(file.type)) {
      fileControl.setErrors({ invalidType: true });
      return;
    }

    if (file.size > maxSize) {
      fileControl.setErrors({ maxSize: true });
      return;
    }

    fileControl.updateValueAndValidity();
    this.uploadOtherAttachment(key);
  }

  /**
   * Uploads an "Other Attachment" through the same reviewer-side endpoint the
   * rectification attachments use. Every row is saved under the shared
   * 'OtherAttachments' category_name and is told apart by its index in
   * responseValue, so the row can be matched back on reload.
   */
  async uploadOtherAttachment(key: string): Promise<void> {
    const file = this.rmassessmentForm.get(key)?.value;
    if (!(file instanceof Blob)) {
      return;
    }

    this.setSprinner.set(true);
    let uploadOtherAttachments = new OnboardingAssesmentModel();
    uploadOtherAttachments.setOnboardingid(this.viewId);
    uploadOtherAttachments.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    uploadOtherAttachments.setAttachments([{
      onboardingid: this.viewId,
      docTypeId: 0,
      category_name: this.otherAttachmentDescription,
      fileName: (file as File).name,
      data: await this.convertToBase64(file as File),
      contentType: file.type,
      responseValue: this.otherAttachmentIndex(key)
    }]);

    const responseData = await this.documentUploadService
      .saveOnboardingassessment(uploadOtherAttachments)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
      this.getAllDocuments();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async getAllDocuments() {
    const responseData1 = await this.rmAssessmentService
      .getRectificationdocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    const allDocuments: OnboardingAssesment[] = responseData1.data.responsedata ?? [];
    this.getRectificationdocuments = allDocuments.filter(
      item => this.otherAttachmentIndexOf(item) === null
    );
    this.otherAttachmentDocuments = allDocuments.filter(
      item => this.otherAttachmentIndexOf(item) !== null
    );
    this.buildOtherAttachments();

  }

  async getcetegorynameDropdownOptions() {

    const responseData = await this.rmAssessmentService
      .getrectificationDocumentsCategorydropdown()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      this.documentCategorynames = responseData.data.responsedata;
    }
  }

  showPreview = false;

  async previewAttachment(controlName: string, filename: string) {
    this.selectedItemFile = controlName;
    await this.loadOtherFile(controlName, filename);
    this.showPreview = true;

  }

  private findAttachment(fileVar: string): OnboardingAssesment | undefined {
    const matches = this.otherAttachmentDocuments?.filter(item => this.otherAttachmentIndexOf(item) === this.otherAttachmentRow(fileVar))
    return matches?.[matches.length - 1];
  }

  async loadOtherFile(category: string, filename: string) {

    const documentId = this.findAttachment(category)?.id;
    
    if (documentId) {
      try {

        const responseData = await this.documentUploadService
          .viewChecklistdocuments(documentId);

        // Create blob URL
        const fileURL = URL.createObjectURL(responseData);


        // Safe URL
        this.selectedDocument =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

      } catch (error) {
        console.error(error);
      }
      this.isPdf = this.rmassessmentForm.get(filename)?.value.toLowerCase().endsWith('.pdf');
      this.currentFileName = this.rmassessmentForm.get(filename)?.value;
      this.resetZoom();
    }
  }

  async previewDoc(category: string, index: number) {
    this.selectedItemFile = category;
    await this.loadFile(category, index);
    this.showPreview = true;

  }

  async loadFile(category: string, index: number) {

    const documentId = this.getRectificationdocuments.find(
      document => document.onboardingDocumentType === category
    )?.id;

    if (documentId) {
      try {

        const responseData = await this.documentUploadService
          .viewChecklistdocuments(documentId);

        // Create blob URL
        const fileURL = URL.createObjectURL(responseData);


        // Safe URL
        this.selectedDocument =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

      } catch (error) {
        console.error(error);
      }
      this.isPdf = this.rectificationAttachemnts.at(index).get('documentFilename')?.value.toLowerCase().endsWith('.pdf');
      this.currentFileName = this.rectificationAttachemnts.at(index).get('documentFilename')?.value;
      this.resetZoom();
    }
  }

  zoomIn(): void {
    this.zoomLevel = Math.min(this.MAX_ZOOM, +(this.zoomLevel + this.ZOOM_STEP).toFixed(2));
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.MIN_ZOOM, +(this.zoomLevel - this.ZOOM_STEP).toFixed(2));
  }

  resetZoom(): void {
    this.zoomLevel = 1;
  }

  closePreview() {
    this.showPreview = false;
    this.resetZoom();
  }


  async getChecklistItems() {
    const responseData = await this.newRepChecklistService
      .getChecklistItems(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });


    if (responseData.status === HttpStatusCode.Ok) {

      this.getchecklistItems = responseData.data.responsedata;
      this.getchecklistItems = this.getchecklistItems.filter(
        x => x.categoryName.startsWith('minimumDocumentCheck_') || x.categoryName.startsWith('subsequentDocumentsCheck_')
      );
      const preferredOrder = [
        "minimumDocumentCheck_",
        "subsequentDocumentsCheck_",
      ];

      const getCategoryOrder = (categoryName = "") => {
        const index = preferredOrder.findIndex(prefix =>
          categoryName.startsWith(prefix)
        );
        return index === -1 ? preferredOrder.length : index;
      };

      const getSuffixNumber = (categoryName = "") => {
        const match = categoryName.match(/_(\d+)$/);
        return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
      };

      this.getchecklistItems.sort((a, b) => {
        const orderA = getCategoryOrder(a.categoryName);
        const orderB = getCategoryOrder(b.categoryName);

        if (orderA !== orderB) {
          return orderA - orderB;
        }

        return getSuffixNumber(a.categoryName) - getSuffixNumber(b.categoryName);
      });

      this.checklistinvalidflag.set(
        this.getchecklistItems.filter(
          x => x.categoryName?.startsWith('minimumDocumentCheck_')
        ).length === 0 ||
        this.getchecklistItems
          .filter(x => x.categoryName?.startsWith('minimumDocumentCheck_'))
          .some(x => x.isCompleted == null || x.isCompleted == false)
      );

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async viewRmAssessment() {
    this.setSprinner.set(true);
    let status = this.data.status;
    const responseData = await this.rmAssessmentService
      .viewRmassessment(this.viewId, status)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    const responseData1 = await this.rmAssessmentService
      .getRectificationdocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      this.viewrmAssessment = responseData.data.responsedata;
      this.status = this.viewrmAssessment.declaration_details?.status;
      if (this.viewrmAssessment?.remark_details[1]?.id != undefined) {
        this.status = 'Rectification';
      }
      // The documents list carries both the rectification attachments and the
      // "Other Attachments" - split them so each section only sees its own rows.
      const allDocuments: OnboardingAssesment[] = responseData1.data.responsedata ?? [];
      this.getRectificationdocuments = allDocuments.filter(
        item => this.otherAttachmentIndexOf(item) === null
      );
      this.otherAttachmentDocuments = allDocuments.filter(
        item => this.otherAttachmentIndexOf(item) !== null
      );
      this.buildOtherAttachments();
      //  Always show at least one row
      if (this.status === 'Rectification') {
        if (this.rectificationAttachemnts.length === 0) {
          this.addRow();
          this.getcetegorynameDropdownOptions();
          this.rmassessmentForm.controls['remarks']?.disable();
        }
      }
      if (this.getRectificationdocuments.length > 0) {
        this.rectificationAttachemnts.clear();
        this.getRectificationdocuments.forEach((item, index) => {
          // if (index !== 0) {
          this.addRow();
          // }
          // if (item.onboardingDocumentType == this.documents.at(index).get('category_name')?.value) {
          this.rectificationAttachemnts.at(index).patchValue({
            categoryName: item.onboardingDocumentType,
            documentFilename: item.fileName
          },)
          // }
        });
      }
      if (this.isReadOnly() == true) {
        this.rectificationAttachemnts?.disable();
      }

      this.rmassessmentForm.controls['name'].setValue(this.viewrmAssessment.declaration_details.fullNameNric);
      if (this.viewrmAssessment.declaration_details.nricNo == '') {
        this.rmassessmentForm.controls['nric'].setValue(this.viewrmAssessment.declaration_details.finPassportNo);
      } else {
        this.rmassessmentForm.controls['nric'].setValue(this.viewrmAssessment.declaration_details.nricNo);
      }
      this.rmassessmentForm.controls['agentchannel'].setValue(this.viewrmAssessment.declaration_details.agentChannel);
      this.rmassessmentForm.controls['hierarchy'].setValue(this.viewrmAssessment.declaration_details.Tier);
      this.rmassessmentForm.controls['designation'].setValue(this.viewrmAssessment.declaration_details.repDesignation);
      this.rmassessmentForm.controls['representativebanding'].setValue(this.viewrmAssessment.declaration_details.representativeBanding);
      this.rmassessmentForm.controls['branch'].setValue(this.viewrmAssessment.declaration_details.branch);
      this.rmassessmentForm.controls['manager'].setValue(this.viewrmAssessment.declaration_details.finacialServiceMan);
      this.rmassessmentForm.controls['remarks'].setValue(this.viewrmAssessment?.remark_details[0]?.remarkContent);
      this.rmassessmentForm.controls['rectificationremarks'].setValue(this.viewrmAssessment?.remark_details[1]?.remarkContent);
      this.rmassessmentForm.controls['declarationaccepted'].setValue(this.viewrmAssessment.declaration_details.rmNotApplicable);
      if (this.rmassessmentForm.get('declarationaccepted')?.value == true) {
        this.rmassessmentForm.controls['rm'].setValue(this.viewrmAssessment.declaration_details.finacialServiceMan);
        this.rmassessmentForm.controls['date'].setValue(this.viewrmAssessment.declaration_details.rmDeclarationDate?.split('T')[0]);
      }

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  async returnByRole() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to return the application ?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        this.setSprinner.set(true);
        let returndata = {
          id: this.viewId,
          status: 'Candidate Submission',
        };

        const responseData = await this.returnbyroleService
          .statusreturn(returndata)
          .then((response) => {
            return JSON.parse(response);
          })
          .catch((error) => {
            // console.error(error);
            return error;
          });
        this.setSprinner.set(false);
        if (responseData.status === HttpStatusCode.Ok) {
          this.snackBarService.openSuccessSnackBar("Application returned successfully!");
          this.router.navigate(['/agent-onboarding']);

        } else {
          if (responseData.code === HttpStatusCode.BadRequest) {
            // Display notification on API failure.
            this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
          }
          if (responseData.code === HttpStatusCode.Unauthorized) {
            this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
            this.router.navigate(['/login']);
          }
        }
      } else {
        // console.log('User cancelled');
      }
    });

  }


  openConfirmDialog() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Are you sure you want to submit this Application?',
        hidecancel: false,
      }
    });

    this.getChecklistItems();
    dialogRef.afterClosed().subscribe(result => {
      if (result.data === true) {
        if (this.rmassessmentForm.get('declarationaccepted')?.value == true) {
          if (this.checklistinvalidflag() === true) {
            this.errormessage = 'Please complete the checklist';
            this.submitted.set(false);
          } else {
            this.submitted.set(true);
            this.saveAndContinue();
          }
        } else {
          this.errormessage = 'Please check the decleartion';
          this.submitted.set(false);
        }

      } else {
        // console.log('User cancelled');
      }
    });
  }

  async saveAndContinue() {
    this.setSprinner.set(true);
    let saveRmassessment = new RmAssessment();
    saveRmassessment.setId(this.viewId);
    if (this.status == 'Rectification') {
      saveRmassessment.setRemarkId(this.viewrmAssessment?.remark_details[1]?.id);
      saveRmassessment.setRemarkContent(this.rmassessmentForm.get('rectificationremarks')?.value);
    } else {
      saveRmassessment.setRemarkId(this.viewrmAssessment?.remark_details[0]?.id);
      saveRmassessment.setRemarkContent(this.rmassessmentForm.get('remarks')?.value);
    }
    saveRmassessment.setAgentChannel(this.rmassessmentForm.get('agentchannel')?.value);
    saveRmassessment.setRepresentativebanding(this.rmassessmentForm.get('representativebanding')?.value);
    saveRmassessment.setRepDesignation(this.rmassessmentForm.get('designation')?.value);
    saveRmassessment.setTier(this.rmassessmentForm.get('hierarchy')?.value);
    saveRmassessment.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    if (this.submitted() == true) {
      saveRmassessment.setRm_not_applicable(this.rmassessmentForm.get('declarationaccepted')?.value);
      saveRmassessment.setRm_declaration_date(this.rmassessmentForm.get('date')?.value + 'T00:00:00Z');
    } else {
      saveRmassessment.setRm_not_applicable(false);
    }

    const responseData = await this.rmAssessmentService
      .saveRmassessment(saveRmassessment)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewRmAssessment();
      if (this.submitted() == true) {
        this.snackBarService.openSuccessSnackBar("Application submitted successfully!");
        this.router.navigate(['/agent-onboarding']);
      } else {
        this.snackBarService.openSuccessSnackBar("Application saved successfully!");
      }

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const result = reader.result as string;

        // Remove metadata prefix
        const base64 = result.split(',')[1];

        resolve(base64);
      };

      reader.onerror = error => reject(error);
    });
  }

}
